// src/store/drawerSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  drawerWidth: 230, // Default drawer width, you can adjust based on your needs
  hasMounted: false,
};

const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    setDrawerWidthJS: (state, action) => {
      state.drawerWidth = action.payload;
    },
    setHasMounted: (state, action) => {
      state.hasMounted = action.payload;
    },
  },
});

export const { setDrawerWidthJS, setHasMounted } = drawerSlice.actions;
export default drawerSlice.reducer;
